import React from 'react';
import './i18n';
import BootstrapComponent from './bootstrap';
import Routes from './Routes';
var App = function () { return (React.createElement(BootstrapComponent, null,
    React.createElement(Routes, null))); };
export default App;
